import { render, staticRenderFns } from "./UploadScreenshot.vue?vue&type=template&id=4f5c65fd"
import script from "./UploadScreenshot.vue?vue&type=script&lang=js"
export * from "./UploadScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports